import { useMutation, UseMutationOptions } from 'react-query'
import { AxiosError } from 'axios'

import { deleteSchedule } from 'api/clients'
import { DELETEScheduleValues } from 'api/types'
import { useClient } from './useClient'

type Options = UseMutationOptions<
  void,
  AxiosError,
  {
    values: DELETEScheduleValues
  }
>

export const useDeleteSchedule = (options?: Options) => {
  const client = useClient()

  return useMutation(async (data: { values: DELETEScheduleValues }) => {
    const { values } = data
    return deleteSchedule({ ...values }, client)
  }, options)
}
